/*
 * title: 页面自定义header
 * author：比诺
 * 功能：
 *  - 自定义样式 style
 *  - 自定义内容 children, 会覆盖默认元素
 *  - 自定义文本 title
 *  - 显示类型 type: "normal", "error", "warning", "normal"为默认值。
 * */

import React from 'react'
import { Flex } from 'hljd'
import { Icon as LegacyIcon } from '@ant-design/compatible'
import styles from './index.module.less'

const config = type => {
  switch (type) {
    case 'error':
      return {
        icon: 'close-circle',
        iconColor: '#FF4B4B',
        headerClass: 'error'
      }
    default:
      return {
        icon: 'info-circle',
        iconColor: '#448afc',
        headerClass: 'normal'
      }
  }
}

export default ({
  type = 'normal',
  title,
  children,
  style = {},
  extra,
  wrapStyle = {},
  onClick = () => {}
}) => {
  const { icon, iconColor, headerClass } = config(type)
  return (
    <div
      className={`page-header-wrap ${styles['page-header-wrap']}`}
      onClick={onClick}
      style={wrapStyle}
    >
      <div
        className={`${styles['page-header']} ${styles[headerClass]}`}
        style={style}
      >
        {children || (
          <Flex>
            <LegacyIcon
              type={icon}
              theme="filled"
              style={{ marginRight: 9, color: iconColor, marginTop: 4 }}
            />
            <span>{title}</span>
            {extra}
          </Flex>
        )}
      </div>
    </div>
  )
}
